// extracted by mini-css-extract-plugin
export default {"container":"dropdown-option_container__hUIwn","label":"dropdown-option_label__bdkiW","center":"dropdown-option_center__9UhHQ","count":"dropdown-option_count__JUGNn"};